import React, { Component } from "react";
import * as pr from "../../common/PrimeComponents";
import * as Log from "../../common/Feedback/Log";

export class DeleteDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: []
    };

    this.logger = Log;
  }

  updateVisibility = (key, value) => {
    this.props.updateVisibility(key, value);
  };

  runDelete = key => {
    this.updateVisibility(key, false);
    this.props.runConfirm();
  };

  render() {
    return (
      <div>
        <pr.Dialog
          header={"Delete " + this.props.header}
          footer={
            <div>
              <pr.Button
                className="secondary-btn"
                label="Yes"
                icon="pi pi-check"
                onClick={() => {
                  this.runDelete(this.props.visibleField);
                }}
                style={{
                  float: "right"
                }}
              />
              <pr.Button
                className="secondary-btn"
                label="No"
                icon="pi pi-times"
                onClick={() => {
                  this.updateVisibility(this.props.visibleField, false);
                }}
                style={{
                  float: "right"
                }}
              />
            </div>
          }
          visible={this.props.isVisible}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.updateVisibility(this.props.visibleField, false)}
        >
          Are you sure you want to delete?
        </pr.Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/DeleteDialog.js